import { render, staticRenderFns } from "./HomeTwo.vue?vue&type=template&id=5c5296a3&scoped=true"
import script from "./HomeTwo.vue?vue&type=script&lang=js"
export * from "./HomeTwo.vue?vue&type=script&lang=js"
import style0 from "./HomeTwo.vue?vue&type=style&index=0&id=5c5296a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5296a3",
  null
  
)

export default component.exports